import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

export default data => {
  const ctasArr = data.iwtCtasRep ? get(data, 'iwtCtasRep', []) : []
  const ctas = ctasArr.map(item => {
    return {
      href: get(item, 'iwtCtasRepLink.url', null),
      title: get(item, 'iwtCtasRepLink.title', null),
    }
  }).filter(item => item.href);

  const image = data.iwtImage ? refactorRespImg(data.iwtImage, [{
    size: 'default',
    key: 'image_size_840x570'
  },{
    size: 'md',
    key: 'image_size_760x516',
  }]) : null;

  return {
    heading: get(data, 'iwtHeading', null),
    description: get(data, 'iwtDescription', null),
    imagePosition: get(data, 'iwtImagePosition', 'left').toLowerCase(),
    ctas,
    image
  }
}